import React from 'react'
import { Provider } from 'react-redux'
import SmartBanner from 'react-smartbanner'
import { PersistGate } from 'redux-persist/integration/react'
import 'SmartBanner.css'
import { AuthProvider } from './authentication/context'
import AppContainer from './Routes'
import store, { persistor } from 'reducers'

const App = (): JSX.Element => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider style={{ flex: 1 }}>
        <AppContainer />
        <SmartBanner
          title={'Orelo'}
          position={'bottom'}
          button={'Ver'}
          storeText={{
            ios: 'Na App Store',
            android: 'Na Google Play',
          }}
          price={{
            ios: 'Grátis',
            android: 'Grátis',
          }}
        />
      </AuthProvider>
    </PersistGate>
  </Provider>
)

export default App
